import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvProcessRelatedAddressEditor.html?raw';

import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import lang from 'dojo/_base/lang';
import _GlobalSelectEntityDialogsMixin from '../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { EvProcessAddress, EvProcessRelatedAddress, EvProcessSEDModes, ProcessTypes } from "./EvProcessTypes";
import HintBox from '../../moreCore/UI/HintBox/HintBox';
import { SelectEntityDialogTypes } from "../../moreCore/_loadingHelpers/SelectEntityDialog";

class EvProcessRelatedAddressEditor extends compose(_StatefulSection, _uiFrameMixin, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private type: ProcessTypes;

    private inputAddress: MdsLax<InstanceType<typeof HintBox>>;

    constructor(type: ProcessTypes) {
        super(...(arguments as unknown as []));
        this.type = type;
    }


    setup(data: EvProcessRelatedAddress): void {
        this.setData(data);
        this.createDefaultButton("ok", lang.hitch(this, this._onClickConfirm));
        let heading = `${data.ref_address.gDisp_Firstname_Name} - ${data.ClassPrintname}`;
        this.show("dlg", heading);
        this.setStartupState("ready");
    }

    _onClickConfirm(e): void {
        this.emit("confirmed", this.getCurrentData());
        this.close();
    } 

    private _onClick_OpenAddressesSED(e) {
        let mode = EvProcessSEDModes[this.type];

        this.loadSelectEntityDialog(e, mode, lang.hitch(this, this._onCallback_Dlg));
    }

    private _onCallback_Dlg(mode: EvProcessSEDModes, data, items: Array<SelectEntityDialogTypes.Item<EvProcessAddress>>, test) {
        switch (mode) {
            case "selectTemplateAddresses":
            case "selectProjectAddresses":
            case "selectBookingAddresses":
                if (items) {
                    let newAddressEntity = items[0].entry.data;

                    this.inputAddress.setValue(newAddressEntity);
                    this.setAttributeValue("c_address_1", newAddressEntity.gDisp_Firstname_Name);
                }
                break;
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.SEDconfigCallfunction = "Webtool_API__EvProcess_GetSEDConfig";

        this.inputAddress.addInlineButton(lang.hitch(this, this._onClick_OpenAddressesSED));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvProcessRelatedAddressEditor);